<template>
  <ConfirmationModal
    :title="forModal.title"
    :accept-text="forModal.acceptBtnText"
    :cancel-text="forModal.declineBtnText"
    :accept-button-props="{ color: 'black' }"
    :cancel-button-props="{ color: 'black' }"
    :disable-btns="btnOnLoading"
    @on-accept="ban"
  >
    <div class="ban-nft-content">
      <p>{{ forModal.text }}</p>
    </div>
  </ConfirmationModal>
</template>

<script>
import { computed, defineComponent, ref } from 'vue';
import { ConfirmationModal } from '@/components/common/modal';
import { confirmModalContent } from '@/components/common/modal/data/confirmModalContent';
import { useStore } from 'vuex';

export default defineComponent({
	name: 'BanModal',
	components: { ConfirmationModal },
	setup (props, { attrs }) {
		const store = useStore();
		const btnOnLoading = ref(false);
		const id = attrs.modalProps.id;
		const type = computed(() => store.state.banned.type);
		const forModal = computed(() => confirmModalContent[type.value]);

		const ban = async () => {
			btnOnLoading.value = true;
			await store.dispatch('banned/ban', id);
			store.dispatch('modal/closeModal');
			btnOnLoading.value = false;
		};

		return {
			forModal,
			ban,
			btnOnLoading,
		};
	},
});
</script>

<style scoped lang="scss">
  .ban-nft-content {
    width: 100%;
    max-width: 360px;
    text-align: center;
    margin: 20px 25px
  }
</style>
